import { SceneLockState } from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import SceneActionGeneral from '../SceneActionGeneral';
import EnumToSelectButton from '@/views/components/EnumToSelectButton/EnumToSelectButton.vue';

@Options({
  name: 'ActionLock',
  components: {
    EnumToSelectButton,
  },
})
export default class ActionLock extends SceneActionGeneral {
  SceneLockState = SceneLockState;

  get isConfirmEnabled() {
    return true;
  }
}
